import React from 'react';
import './Header.css';
import defaultHeaderLogo from '../../../images/xpress_header_image.png';

export default class Header extends React.Component {
	render() {
		let logo;
		let tagline;

		if(this.props.filler) {
			logo = (<div style={{height: '112px'}}/>);
		}
		else {
			logo = (<img className="headerLogo" src={this.props.logoPath ? this.props.logoPath : defaultHeaderLogo} alt="Logo"/>);

			if(this.props.taglinePath) {
				tagline = (<img className="headerTagline" src={this.props.taglinePath} alt="Tagline"/>);
			}
		}
		return (
			<div className="d-print-none" style={{paddingBottom: '1em'}}>
				<div className="container" style={{paddingTop: '1em', paddingBottom: '1em'}}>
					<div className="row justify-content-center text-center my-auto">
						<div className='col-sm-6 my-auto'>{logo}</div>
						{tagline && <div className='col-sm-6 my-auto'>{tagline}</div>}
					</div>
				</div>
				<hr className="style2"/>
			</div>
		);
	}
}